import React, {useState, useContext, useEffect} from "react";
import { NamePositionContext } from "../../contexts/NamePositionContext";

const InputPosition = (props) => {
    const [position,setPosition] = useState("");
    const {dispatch} = useContext(NamePositionContext);
    
    const handleChange = (e) => setPosition(e.target.value);

    useEffect(() => {
        dispatch({ type: 'UPDATE_POSITION', position })
    }, [position])
    return (
        <div className='input-details'>
            <input onChange={handleChange}
                placeholder={props.position}
                style={props.positionStyleObj} />
        </div>
    )};

export default InputPosition;
